import { Component } from '@angular/core';

@Component({
    selector: 'sgt-objetivo-campanha-badge-bonificacao',
    templateUrl: './objetivo-campanha-badge-bonificacao.component.html',
    styleUrls: ['./objetivo-campanha-badge-bonificacao.component.less']
})
export class ObjetivoCampanhaBadgeBonificacaoComponent {

}
